/**
 * innerHTML property for SVGElement
 * Copyright(c) 2010, Jeff Schiller
 *
 * Licensed under the Apache License, Version 2
 *
 * Works in a SVG document in Chrome 6+, Safari 5+, Firefox 4+ and IE10+.
 * Works in a HTML5 document in Chrome 7+, Firefox 4+ and IE10+.
 * Works in Opera 12.16
 *
 * I haven't decided on the best name for this property - thus the duplication.
 *
 */
"use strict";
if ((navigator.userAgent.match(/MSIE/) || navigator.userAgent.match(/Trident/)) && !("classList" in SVGElement.prototype)) {
    Object.defineProperty(SVGElement.prototype, "classList", {
        get: Object.getOwnPropertyDescriptor(HTMLElement.prototype, "classList").get,
        set: Object.getOwnPropertyDescriptor(HTMLElement.prototype, "classList").set,
    });
}


(function() {
    var ns = ['xmlns="http://www.w3.org/2000/svg"', 'xmlns:xlink="http://www.w3.org/1999/xlink"'].join(" "),
        single_tags = {
            "BR"             : 1,
            "ellipse"        : 1,
            "feComposite"    : 1,
            "feFlood"        : 1,
            "feGaussianBlur" : 1,
            "feOffset"       : 1,
            "HR"             : 1,
            "image"          : 1,
            "IMG"            : 1,
            "INPUT"          : 1,
            "line"           : 1,
            "path"           : 1,
            "polygon"        : 1,
            "rect"           : 1,
        },
        div = document.createElement('div'),
        serializeXML = function(node, output) {
            var nodeType = node.nodeType,
                nodeName = node.nodeName,
                attrMap, attrNode, attrname, attrval, i, len;
            if (nodeType === Node.TEXT_NODE) {
                // Replace special XML characters with their entities.
                output.push(node.innerSVG);
            } else if (nodeType === Node.ELEMENT_NODE) {
                // Serialize Element nodes.
                output.push("<", node.tagName);
                if (node.hasAttributes()) {
                    attrMap = node.attributes;
                    for (i = 0, len = attrMap.length; i < len; ++i) {
                        attrNode = attrMap.item(i);
                        attrname = attrNode.name;
                        if (nodeName === "image" && attrname === "href" && attrNode.namespaceURI === "http://www.w3.org/1999/xlink") {
                            attrname = "xlink:href";
                        }
                        attrval = attrNode.value.replace(/&/g, "&amp;").replace(/"/g, "&quot;");
                        output.push(" ", attrname, '="', attrval, '"');
                    }
                }
                if (node.hasChildNodes()) {
                    output.push(">");
                    var childNodes = node.childNodes;
                    for (i = 0, len = childNodes.length; i < len; ++i) {
                        serializeXML(childNodes.item(i), output);
                    }
                    output.push("</", node.tagName, ">");
                } else if (single_tags[node.tagName]) {
                    output.push("/>");
                } else {
                    output.push("></", node.tagName, ">");
                }
            } else if (nodeType === Node.COMMENT_NODE) {
                // TODO(codedread): Replace special characters with XML entities?
                output.push("<!--", node.nodeValue, "-->");
            } else {
                // TODO: Handle CDATA nodes.
                // TODO: Handle ENTITY nodes.
                // TODO: Handle DOCUMENT nodes.
                throw "Error serializing XML. Unhandled node of type: " + nodeType;
            }
        },
        innerHTML = function() {
            let output = [],
                childNode = this.firstChild;
            while (childNode) {
                serializeXML(childNode, output);
                childNode = childNode.nextSibling;
            }
            return output.join("");
        },
        outerHTML = function() {
            let output = [];
            serializeXML(this, output);
            return output.join("");
        },
        innerText = function() {
            return this.textContent.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(">", "&gt;");
        };

    Object.defineProperty(Text.prototype, "innerSVG", {
        get: innerText,
        set: function(markupText) {
//            this.innerHTML = markupText;
        }
    });

    SVGElement.prototype.append = function(content) {
        if (content instanceof SVGElement) {
            this.appendChild(content);
        } else if (typeof content === "string") {
            var html = ['<svg version="1.1" ', ns, ">", content, "</svg>"].join(""),
                node, childNode;
            div.innerHTML = html,
            node = div.children[0];
            while (childNode = node.firstChild) {
                this.appendChild(childNode);
            }
            div.innerHTML = '';
        }
    };

    // The innerHTML DOM property for SVGElement.
    Object.defineProperty(SVGElement.prototype, "innerHTML", {
        get: innerHTML,
        set: function(value) {
            while (this.firstChild) {
                this.removeChild(this.firstChild);
            }
            this.append(value);
        }
    });

    Object.defineProperty(SVGElement.prototype, "innerSVG", {
        get: innerHTML,
        set: function(markupText) {
            this.innerHTML = markupText;
        }
    });

    Object.defineProperty(HTMLElement.prototype, "innerSVG", {
        get: function() {
            return innerHTML.call(this);
        },
        set: function(markupText) {
            this.innerHTML = markupText;
        }
    });

    Object.defineProperty(SVGElement.prototype, "outerSVG", {
        get: outerHTML,
        set: function(markupText) {
        }
    });

    Object.defineProperty(HTMLElement.prototype, "outerSVG", {
        get: outerHTML,
        set: function(markupText) {
        }
    });
})();
